import { usePathname, useSearchParams } from 'next/navigation';
import {
  parsePathnameToSearchType,
  type SearchType,
} from '@/lib/publicSearchPaths';
import { SEARCH_PARAM } from '@/constants/searchParams';
import { SEARCH_TYPE } from '@/constants/searchType';

export type { SearchType };

export function useSearchType(): SearchType {
  const pathname = usePathname();
  const params = useSearchParams();

  const fromPath = parsePathnameToSearchType(pathname ?? '');
  if (fromPath) return fromPath;

  const fromParams = params?.get(SEARCH_PARAM.SEARCH_TYPE) as SearchType | null;
  if (fromParams) return fromParams;

  const isMemberDetailPage = /\/members\/.+/.test(pathname ?? '');
  if (isMemberDetailPage) return SEARCH_TYPE.MEMBERS;

  return SEARCH_TYPE.ANIMAL;
}
